import { BillingPeriod } from '@enmon/commons/lib/enmon';
import type { VFC } from 'react';
import { useIntl } from '@/components/formatted_message/FormattedMessage';
import type { SelectProps } from 'antd';
import { BILLING_PERIOD_TRANSLATED } from '@/common/messages/supply_point';
import { Select } from './Select';

const BILLING_PERIOD_OPTIONS = [
  BillingPeriod.Month,
  BillingPeriod.Quarter,
  BillingPeriod.HalfYear,
  BillingPeriod.Year,
  BillingPeriod.PerInvoice,
];

export const BillingPeriodSelect: VFC<SelectProps> = props => {
  const intl = useIntl();

  return (
    <Select
      allowClear
      data-cy="billingPeriod"
      options={BILLING_PERIOD_OPTIONS.map(period => ({
        label: intl.formatMessage(BILLING_PERIOD_TRANSLATED[period]),
        value: period,
      }))}
      {...props}
    />
  );
};
